import React from "react";
import styled, { keyframes } from "styled-components";

// A change older than this is not replayed when the host re-mounts, such as the caption editor on a split.
const RECENT_CHANGE_MS = 2000;

const settle = keyframes`
  from { opacity: 0.85; }
  to { opacity: 0; }
`;

const Glow = styled.div<{ $radius: number; $inset: number }>`
  position: absolute;
  inset: ${props => -props.$inset}px;
  z-index: 1;
  border-radius: ${props => props.$radius}px;
  background-color: ${props => props.theme.colors.primarySubtle};
  box-shadow: 0 0 0 2px ${props => props.theme.colors.primaryLight};
  opacity: 0;
  pointer-events: none;
  animation: ${settle} 1.1s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

interface AgentChangeGlowProps {
  touchedAt: number | null; // when Create AI last changed this part of the post; a new value replays the glow
  radius?: number;
  inset?: number; // keep at 0 inside overflow: auto hosts, a negative inset would add scrollable overflow
}

// Render inside a position: relative host; the key remounts the overlay so every change plays it again.
const AgentChangeGlow: React.FC<AgentChangeGlowProps> = ({ touchedAt, radius = 10, inset = 0 }) => {
  if (!touchedAt || Date.now() - touchedAt > RECENT_CHANGE_MS) return null;
  return <Glow key={touchedAt} $radius={radius} $inset={inset} aria-hidden="true" />;
};

export default AgentChangeGlow;
